import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchPayments } from '../api/authApi';
import { DataTable } from './DataTable';
import { LoadingSkeleton } from './LoadingSkeleton';
import { StatusBadge } from './StatusBadge';

export function PaymentsTable({ customerId, tenantId, emptyMessage }) {
  const navigate = useNavigate();
  const { t } = useTranslation(['billing', 'common']);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = {};
    if (customerId) params.customer_id = customerId;
    if (tenantId) params.tenant_id = tenantId;
    fetchPayments(params)
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, [customerId, tenantId]);

  const columns = useMemo(() => [
    {
      id: 'amount',
      label: t('amount'),
      render: (p) => `${p.amount} ${p.currency}`,
    },
    {
      id: 'status',
      label: t('common:status'),
      render: (p) => <StatusBadge status={p.status} category="payment" size="Sm" />,
    },
    {
      id: 'due',
      label: t('due'),
      render: (p) => (p.due_at ? new Date(p.due_at).toLocaleDateString() : '—'),
    },
    {
      id: 'paid',
      label: t('paid'),
      render: (p) => (p.paid_at ? new Date(p.paid_at).toLocaleDateString() : '—'),
    },
  ], [t]);

  if (loading) {
    return <LoadingSkeleton type="Table" rows={3} columns={4} />;
  }

  return (
    <DataTable
      type="Default"
      embedded
      columns={columns}
      rows={items}
      emptyMessage={emptyMessage}
      onRowClick={() => navigate('/payments')}
    />
  );
}
